import type { FC } from 'react';
import { SpringFrameworkWrapper } from './SpringFramework.styled';

interface SpringFrameworkProps {}

const SpringFramework: FC<SpringFrameworkProps> = () => (
 <SpringFrameworkWrapper>
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Spring Framework</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">Spring is a popular application development framework for enterprise Java. The Spring Framework targets to make J2EE development easier by providing a comprehensive programming and configuration model for modern Java-based enterprise applications. It helps in developing any Java application, but mostly its uses for building the web.</p>
      <p className="text-align-justify">In this section, the below-mentioned topics will be covered:</p>
      <ul className="text-align-justify">
         <li><a href="/spring-mvc">Spring MVC</a></li>
         <li><a href="/spring-boot">Spring Boot</a></li>
      </ul>
   </div>
 </SpringFrameworkWrapper>
);

export default SpringFramework;
